
const SET_POIS = (state, payload) => { state.pois = payload }
const RESET_POIS = (state, payload) => { state.pois = [] }
const SET_PRODUCTS = (state, payload) => { state.products = payload }
const SET_PRODUCTS_MAP = (state, payload) => { state.map = payload }

const SET_BAR_CHART_ARRECADACAO = (state, payload) => {state.barChartArrecadacao = payload }
const RESET_BAR_CHART_ARRECADACAO = (state) => { state.barChartArrecadacao = {} }

const SET_BAR_CHART_PRODUTIVIDADE = (state, payload) => {state.barChartProdutividade = payload }
const RESET_BAR_CHART_PRODUTIVIDADE = (state) => { state.barChartProdutividade = {} }

const SET_BAR_CHART_HORARIO = (state, payload) => {state.barChartHorario = payload }
const RESET_BAR_CHART_HORARIO = (state) => { state.barChartHorario = {} }

const SET_BAR_CHART_VISITANTES = (state, payload) => {state.barChartVisitantes = payload }
const RESET_BAR_CHART_VISITANTES = (state) => { state.barChartVisitantes = {} }

const SET_BAR_CHART_TAMANHO = (state, payload) => {state.barChartTamanho = payload }
const RESET_BAR_CHART_TAMANHO = (state) => { state.barChartTamanho = {} }

const SET_DOUGHNUT_CHART_ATRATIVO = (state, payload) => {state.doughnutChartVisitantes = payload }
const RESET_DOUGHNUT_CHART_ATRATIVO = (state) => { state.doughnutChartVisitantes = {} }

const SET_BAR_CHART_RANKING_VISITANTES = (state, payload) => {state.barChartRankingVisitantes = payload }
const RESET_BAR_CHART_RANKING_VISITANTES = (state) => { state.barChartRankingVisitantes = {} }

const SET_USE_CHART_CACHE = (state, payload) => {state.useChartCache = payload}
const RESET_USE_CHART_CACHE = (state) => { state.useChartCache = false }

const SET_CACHE_LIMIT_DATE = (state, payload) => {
  if(!payload){
    payload = 60
  }
  var cacheLimiteDate = new Date()
  cacheLimiteDate.setTime(cacheLimiteDate.getTime()+payload*60*1000)
  state.cacheLimiteDate = cacheLimiteDate.getTime()
}
const RESET_CACHE_LIMIT_DATE = (state) => {
  var now = new Date()
  state.cacheLimiteDate = now.getTime()
}

const SET_YESTERDAY_TOTAL_CLIENTS = (state, payload) => {state.stateYesterdayTotalClients = payload }
const RESET_YESTERDAY_TOTAL_CLIENTS = (state) => { state.stateYesterdayTotalClients = 0 }

const SET_TOMORROW_TOTAL_CLIENTS = (state, payload) => {state.stateTomorrowTotalClients = payload }
const RESET_TOMORROW_TOTAL_CLIENTS = (state) => { state.stateTomorrowTotalClients = 0 }

const SET_TODAY_TOTAL_CLIENTS = (state, payload) => {state.stateTodayTotalClients = payload }
const RESET_TODAY_TOTAL_CLIENTS = (state) => { state.stateTodayTotalClients = [ { title: 'confirmados', value: 0 }, { title: 'checkin', value: 0 } ] }

const SET_FILTERED_BILL_ITENS_AMOUNT = (state, payload) => {state.stateFilteredBillItensAmount = payload }
const RESET_FILTERED_BILL_ITENS_AMOUNT = (state) => { state.stateFilteredBillItensAmount = [{ title: '', value: 0}, {title: '', value: 0}, {title: '', value: 0}] }

export default {
    SET_POIS,
    RESET_POIS,
    SET_PRODUCTS,
    SET_PRODUCTS_MAP,

    SET_BAR_CHART_ARRECADACAO,
    RESET_BAR_CHART_ARRECADACAO,
    SET_BAR_CHART_PRODUTIVIDADE,
    RESET_BAR_CHART_PRODUTIVIDADE,
    SET_BAR_CHART_HORARIO,
    RESET_BAR_CHART_HORARIO,
    SET_BAR_CHART_VISITANTES,
    RESET_BAR_CHART_VISITANTES,
    SET_DOUGHNUT_CHART_ATRATIVO,
    RESET_DOUGHNUT_CHART_ATRATIVO,
    SET_BAR_CHART_TAMANHO,
    RESET_BAR_CHART_TAMANHO,
    SET_BAR_CHART_RANKING_VISITANTES,
    RESET_BAR_CHART_RANKING_VISITANTES,

    SET_USE_CHART_CACHE,
    RESET_USE_CHART_CACHE,
    SET_CACHE_LIMIT_DATE,
    RESET_CACHE_LIMIT_DATE,

    SET_YESTERDAY_TOTAL_CLIENTS,
    RESET_YESTERDAY_TOTAL_CLIENTS,
    SET_TOMORROW_TOTAL_CLIENTS,
    RESET_TOMORROW_TOTAL_CLIENTS,
    SET_TODAY_TOTAL_CLIENTS,
    RESET_TODAY_TOTAL_CLIENTS,
    SET_FILTERED_BILL_ITENS_AMOUNT,
    RESET_FILTERED_BILL_ITENS_AMOUNT,
}
